import 'css/desktop/search.scss';

import 'js/desktop/common/common.jquery.js';

(function() {
  var bignewsMetadata = JSON.parse($('#bignews__metadata').text().trim());
  var cx = bignewsMetadata.google_search_id;
  var gcse = document.createElement('script');
  gcse.type = 'text/javascript';
  gcse.async = true;
  gcse.src = (document.location.protocol == 'https:' ? 'https:' : 'http:') +
      '//www.google.com/cse/cse.js?cx=' + cx;
  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(gcse, s);
})();
